export {};
//# sourceMappingURL=user.js.map